import { CubeTransparentIcon, HomeIcon, ChartBarSquareIcon } from '@heroicons/react/24/outline';
import { ArrowPathRoundedSquareIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

export const demoPageURI = '/develocity/product-tour';

export const attributePageURIs = {
  HOME: 'home',
  ACCELERATE: 'accelerate',
  OBSERVE: 'observe',
  TROUBLESHOOT: 'troubleshoot',
} as const;

interface IconProp {
  active: boolean;
}

export const routes: { route: string; name: string; Icon: ({ active }: IconProp) => React.ReactElement }[] = [
  {
    route: `${demoPageURI}/${attributePageURIs.HOME}/`,
    name: 'Welcome',
    Icon({ active }: IconProp) {
      return (
        <HomeIcon
          className={clsx(
            'size-6 transition-colors group-hover:text-gradle-blue',
            active ? 'text-gradle-blue' : 'text-gray-3',
          )}
        />
      );
    },
  },
  {
    route: `${demoPageURI}/${attributePageURIs.ACCELERATE}/`,
    name: 'Accelerate',
    Icon({ active }: IconProp) {
      return (
        <CubeTransparentIcon
          className={clsx(
            'size-6 transition-colors group-hover:text-gradle-blue',
            active ? 'text-gradle-blue' : 'text-gray-3',
          )}
        />
      );
    },
  },
  {
    route: `${demoPageURI}/${attributePageURIs.TROUBLESHOOT}/`,
    name: 'Troubleshoot',
    Icon({ active }: IconProp) {
      return (
        <ArrowPathRoundedSquareIcon
          className={clsx(
            'size-6 transition-colors group-hover:text-gradle-blue',
            active ? 'text-gradle-blue' : 'text-gray-3',
          )}
        />
      );
    },
  },
  {
    route: `${demoPageURI}/${attributePageURIs.OBSERVE}/`,
    name: 'Observe',
    Icon({ active }: IconProp) {
      return (
        <ChartBarSquareIcon
          className={clsx(
            'size-6 transition-colors group-hover:text-gradle-blue',
            active ? 'text-gradle-blue' : 'text-gray-3',
          )}
        />
      );
    },
  },
];
